<div class="auth-error">
  <!--
    The alert holds ONLY what is announced once: the heading, the reason, and the support address. This
    page replaces the whole view after a failed sign-in, so without the alert role and the focus() in
    ngAfterViewInit a screen-reader user is told nothing about what happened.
  -->
  <div #errorAlert class="auth-error__panel" role="alert" tabindex="-1">
    <h1 class="auth-error__heading">{{ heading }}</h1>

    <p class="auth-error__message">{{ errorMessage }}</p>

    <!--
      A mailto link, not prose. The people who see the duplicate-account message are being asked to
      contact support as the only way forward, and they are about to lose the page.
    -->
    <p *ngIf="showSupportContact" class="auth-error__support">
      Please email <a [href]="'mailto:' + supportEmail">{{ supportEmail }}</a> and we will sort it out.
    </p>

    <!--
      The FACT of the sign-out, announced once as part of the alert. The ticking number below is not
      announced at all: it lived inside the alert and changed every second, and an assertive region
      interrupts on every change — so a screen reader restarted at "4 seconds... 3 seconds..." and the
      reason for the refusal was never heard in full.
    -->
    <p *ngIf="autoLogout" class="auth-error__sr-only">You will be signed out of this page shortly.</p>
  </div>

  <div class="auth-error__footer">
    <p *ngIf="autoLogout" class="auth-error__countdown" aria-hidden="true">{{ countMessage }}</p>

    <!--
      Shown instead of the countdown whenever something went wrong and the page is not leaving on its own:
      signing in again cannot fix the problem, or the support address is on screen and must not be taken
      away. The person leaves when they have finished reading, rather than the page deciding for them.
      Outside the alert, because a live region is for content that is announced, not for controls.

      Chosen by clearVisionSessionOnDisplay, so every error code with no countdown must set it or it gets
      the link below instead. The spec holds that for every code.
    -->
    <button
      *ngIf="!autoLogout && clearVisionSessionOnDisplay"
      type="button"
      class="auth-error__logout"
      (click)="logOut()"
    >
      Return to sign-in
    </button>

    <!-- A bare visit is not an authentication failure. Return to the app without clearing either session. -->
    <a *ngIf="!autoLogout && !clearVisionSessionOnDisplay" class="auth-error__logout" routerLink="/">
      Return to Vision
    </a>
  </div>
</div>
